import { useMemo } from 'react';
import { EditorContent, type JSONContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import { decodeRichText, messageText } from '../ChatRichTextEditor';

function plainTextDocument(message: string): JSONContent {
	return {
		type: 'doc',
		content: message.split('\n').map((line) => ({
			type: 'paragraph',
			...(line ? { content: [{ type: 'text', text: line }] } : {}),
		})),
	};
}

export function RichTextMessage({ message }: { message?: unknown }) {
	const normalizedMessage = messageText(message);
	const legacyContent = useMemo(() => decodeRichText(normalizedMessage), [normalizedMessage]);
	if (legacyContent) return <LegacyRichTextMessage content={legacyContent} />;

	return (
		<div className="space-y-1 break-words [&_code]:rounded [&_code]:bg-black/10 [&_code]:px-1 [&_ol]:list-decimal [&_ol]:pl-5 [&_p]:min-h-5 [&_ul]:list-disc [&_ul]:pl-5">
			<ReactMarkdown remarkPlugins={[remarkGfm]}>{normalizedMessage}</ReactMarkdown>
		</div>
	);
}

function LegacyRichTextMessage({ content }: { content: JSONContent }) {
	const editor = useEditor({
		extensions: [StarterKit],
		content,
		editable: false,
		editorProps: {
			attributes: {
				class: 'space-y-1 break-words outline-none [&_code]:rounded [&_code]:bg-black/10 [&_code]:px-1 [&_ol]:list-decimal [&_ol]:pl-5 [&_ul]:list-disc [&_ul]:pl-5',
			},
		},
	}, [content]);

	return <EditorContent editor={editor} />;
}
